import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError, IClientApiDependencySegment } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { MarkupProfileAction } from '../markupProfile.action';
import { MarkupProfileTranslator } from '../markupProfile.translator';

type IDependencies = IClientApiDependencySegment;

export const updateMarkupProfileEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(MarkupProfileAction.update.started),
  mergeMap((params) => {
    const { payload, resolve } = params;

    return dependencies.api.updateMarkupProfile(MarkupProfileTranslator.toApi(payload)).pipe(
      mergeMap(() => {
        resolve(payload.markupProfileId);

        return [
          MarkupProfileAction.update.done({ params }),
        ];
      }),
      catchApiError((error) => {
        return [
          MarkupProfileAction.update.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
